const FALLBACK = [-41.2835, 174.7427];
// singleton requet, should fire immediately
export const homeLocationPromise = fetch("https://3.kyle.kiwi")
    .then((r) => r.json())
    .then((res) => [res.lat, res.lon])
    .catch(() => FALLBACK);
